import { useQuery } from '@tanstack/react-query';
import { gitClient } from '@terra/shared-rest-clients-git';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';
import { getAuthHeaders } from '../../utils/authHeaders';

export function useApplicationGitIntegrations({
  applicationId,
  tenantId,
}: {
  applicationId?: string;
  tenantId?: string;
}) {
  return useQuery({
    queryKey: ['git-integration', applicationId],
    queryFn: async () => {
      if (!applicationId || !tenantId) {
        return null;
      }

      const authHeaders = await getAuthHeaders();
      const response = await gitClient.getApplicationGitIntegrations({
        params: { applicationId },
        overrideClientOptions: {
          baseUrl: `${getCurrentGatewayUrl()}/git`,
        },
        extraHeaders: {
          ...authHeaders,
        },
      });

      if (response.status === 200) {
        return response.body;
      }

      return null;
    },
    enabled: !!applicationId && !!tenantId,
    refetchOnWindowFocus: false,
  });
}
